document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product__accordion details').forEach((detail) => {
    const summary = detail.querySelector('summary');
    const content = detail.querySelector('.accordion__content');

    // 1) On page load, remember if it should start open or closed:
    if (detail.hasAttribute('open')) {
      // Leave height as “auto” for fully expanded panels
      detail.style.height = 'auto';
    } else {
      // Force closed panels to exactly summary’s height
      detail.style.height = summary.offsetHeight + 'px';
    }

    summary.addEventListener('click', function (e) {
      e.preventDefault();

      // Measure summary’s fixed height
      const summaryHeight = summary.offsetHeight;

      if (!detail.hasAttribute('open')) {
        // ─── OPENING ───
        // 1a) Set detail’s height to summaryHeight (starting point)
        detail.style.height = summaryHeight + 'px';

        // 1b) Temporarily set [open] so content appears (but keep height pinned)
        detail.setAttribute('open', '');

        // 1c) Measure the new full height (summary + content)
        const fullHeight = detail.scrollHeight;

        // 1d) On next frame, animate detail.height → fullHeight
        requestAnimationFrame(() => {
          detail.style.transition = 'height 0.4s ease';
          detail.style.height = fullHeight + 'px';
        });

        // 1e) After transition, clear inline height so it becomes “auto”
        detail.addEventListener('transitionend', function handler(evt) {
          if (evt.propertyName === 'height') {
            detail.style.height = 'auto';
            detail.removeEventListener('transitionend', handler);
          }
        });
      } else {
        // ─── CLOSING ───
        // 2a) Pin detail.height to its current full height
        detail.style.height = detail.offsetHeight + 'px';

        // 2b) On next frame, animate detail.height → summaryHeight
        requestAnimationFrame(() => {
          detail.style.transition = 'height 0.4s ease';
          detail.style.height = summaryHeight + 'px';
        });

        // 2c) Once the height transition ends, remove [open] and keep height at summaryHeight
        detail.addEventListener('transitionend', function handler(evt) {
          if (evt.propertyName === 'height') {
            detail.removeAttribute('open');
            detail.style.height = summaryHeight + 'px';
            detail.removeEventListener('transitionend', handler);
          }
        });
      }
    });
  });
});
